import { ReactElement, ReactNode } from "react";

const size = 32;

function cleanPercentage(percentage: number): number {
  if (!Number.isFinite(+percentage) || percentage < 0) {
    return 0;
  }
  return Math.min(+percentage, 100);
}

function Circle({ color, percentage }: { color: string; percentage?: number }): ReactElement {
  const r = 11;
  const circ = 2 * Math.PI * r;
  const strokePct = ((100 - (percentage ?? 0)) * circ) / 100;
  return (
    <circle
      r={r}
      cx={size * 0.5}
      cy={size * 0.5}
      fill="transparent"
      stroke={strokePct !== circ ? color : ""} // remove colour as 0% sets full circumference
      strokeWidth="6px"
      strokeDasharray={circ}
      strokeDashoffset={percentage ? strokePct : 0}
    ></circle>
  );
}

function Pie({ color, percentage }: { color: string; percentage: number }): ReactElement {
  const pct = cleanPercentage(percentage);
  const halfSize = size * 0.5;
  return (
    <svg width={32} height={32} viewBox={`0 0 ${size - 1} ${size - 1}`}>
      <g transform={`rotate(-90 ${`${halfSize} ${halfSize}`}) scale(1 -1) translate(0 -31)`}>
        <Circle color={color} percentage={pct ?? 0} />
      </g>
    </svg>
  );
}

export function ProgressCircle({ percentage }: { percentage: number | undefined }): ReactNode {
  return <Pie color="#659E7A" percentage={percentage ?? 0} />;
}
